import {
    PARAMENTOR_RESET,
    PARAMENTOR_BUSY,

    PARAMENTOR_BANDMATERIALIEN_LIST,
    PARAMENTOR_BANDBESCHICHTUNGEN_LIST,
    PARAMENTOR_FORMEN_LIST,
    PARAMENTOR_TRAEGER_TYPEN_LIST,
    PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST,
    PARAMENTOR_VERGUETUNGSARTEN_LIST,
    PARAMENTOR_GEFUEGEARTEN_LIST,
    PARAMENTOR_KUEHLUNGSARTEN_LIST,
    PARAMENTOR_LEISTUNGSVORGABEN_LIST,
    PARAMENTOR_PRODUKTE_LIST,
    PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNGEN_LIST,

    PARAMENTOR_MASCHINENHERSTELLER,
    PARAMENTOR_MASCHINE,
    PARAMENTOR_SAEGEBANDABMESSUNG,
    PARAMENTOR_BANDMATERIALTYP,
    PARAMENTOR_BANDBESCHICHTUNG,
    PARAMENTOR_ERZEUGNIS,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_FORM,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_DURCHMESSER,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_HOEHE,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_WANDSTAERKE,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_TYP,
    PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_ABMESSUNG,
    PARAMENTOR_ERZEUGNIS_WERKSTOFF,
    PARAMENTOR_ERZEUGNIS_WERKSTOFFGRUPPE,
    PARAMENTOR_VERGUETUNGSART,
    PARAMENTOR_GEFUEGEART,
    PARAMENTOR_KUEHLUNGSART,
    PARAMENTOR_LEISTUNGSVORGABE,
    PARAMENTOR_LAGENSCHNITT,
    PARAMENTOR_ANZAHLPROLAGE,
    PARAMENTOR_ANZAHLLAGEN,
    PARAMENTOR_VORHANDENES_SAEGEBAND,
    PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNG,

    PARAMENTOR_ERROR_SPANNBEREICH,

    PARAMENTOR_PRODUKTEMPFEHLUNG,
    PARAMENTOR_PARAMETEREMPFEHLUNG,

    PARAMENTOR_KOSTEN_MASCHINENKOSTEN,
    PARAMENTOR_KOSTEN_KOSTENPROBEDIENER,
    PARAMENTOR_KOSTEN_PREISPROBAND,
    PARAMENTOR_KOSTEN_STANDFLAECHE,
    PARAMENTOR_KOSTEN_STANDFLAECHE_TYP,
    PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER,
    PARAMENTOR_KOSTEN_KOSTENERSPARNIS,

    ParamentorActionTypes,
    PARAMENTOR_PRODUKTEMPFEHLUNG_FAVORITES_LIST,
    PARAMENTOR_SESSIONS,
    PARAMENTOR_SESSION_DELETED,
    PARAMENTOR_SESSION_ADDED,
} from "./actiontypes";

import { ParamentorState } from './types';

const initialState: ParamentorState = {
    busy: 0,

    bandmaterialienList: [],
    bandbeschichtungenList: [],
    formenList: [],
    traegerTypenList: [],
    traegerAbmessungenList: [],
    verguetungsartList: [],
    gefuegeartenList: [],
    kuehlungsartenList: [],
    leistungsvorgabenList: [],

    bandmaterialtyp: 1,
    bandbeschichtung: 1,
    erzeugnis: {
        form: 1,
    },
    verguetungsart: 1,
    gefuegeart: 1,
    kuehlungsart: 2,
    leistungsvorgabe: 1,
    lagenschnitt: false,
    anzahlLagen: 1,
    anzahlProLage: 1,

    produkteList: [],
    vorhandenesSaegebandAusfuehrungenList: [],

    spannbereichError: false,

    standflaecheTypLevel1: 1,
    standflaecheTypLevel2: 1,
    standflaecheTypLevel3: 1,
    standflaecheTypVorhandenesSaegeband: 1,

    maschinenProBedienderLevel1: 1,
    maschinenProBedienderLevel2: 1,
    maschinenProBedienderLevel3: 1,
    maschinenProBedienderVorhandenesSaegeband: 1,
    sessions: [],
};

export function paramentorReducer(state = initialState, action: ParamentorActionTypes): ParamentorState {
    switch (action.type) {
        case PARAMENTOR_RESET:
            return {
                ...initialState,
            };

        case PARAMENTOR_BUSY:
            let paramentorBusy = action.busy ? (state.busy += 1) : (state.busy -= 1);
            if (paramentorBusy < 0) {
                paramentorBusy = 0;
            }
            return {
                ...state,
                busy: paramentorBusy,
            };

            case PARAMENTOR_BANDMATERIALIEN_LIST:
            return {
                ...state,
                bandmaterialienList: action.bandmaterialienList,
            };

        case PARAMENTOR_BANDBESCHICHTUNGEN_LIST:
            return {
                ...state,
                bandbeschichtungenList: action.bandbeschichtungenList,
            };

        case PARAMENTOR_FORMEN_LIST:
            return {
                ...state,
                formenList: action.formentList,
            };

        case PARAMENTOR_TRAEGER_TYPEN_LIST:
            return {
                ...state,
                traegerTypenList: action.traegerTypenList,
            };

        case PARAMENTOR_TRAEGER_ABMESSUNGEN_LIST:
            return {
                ...state,
                traegerAbmessungenList: action.traegerAbmesungenList,
            };

        case PARAMENTOR_VERGUETUNGSARTEN_LIST:
            return {
                ...state,
                verguetungsartList: action.verguetungsartList,
            };

        case PARAMENTOR_GEFUEGEARTEN_LIST:
            return {
                ...state,
                gefuegeartenList: action.gefuegeartenList,
            };

        case PARAMENTOR_KUEHLUNGSARTEN_LIST:
            return {
                ...state,
                kuehlungsartenList: action.kuehlungsartenList,
            };

        case PARAMENTOR_LEISTUNGSVORGABEN_LIST:
            return {
                ...state,
                leistungsvorgabenList: action.leistungsvorgabenList,
            };

        case PARAMENTOR_PRODUKTE_LIST:
            return {
                ...state,
                produkteList: action.produkteList,
            };

        case PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNGEN_LIST:
            return {
                ...state,
                vorhandenesSaegebandAusfuehrungenList: action.vorhandenesSaegebandAusfuehrungenList,
            };

        case PARAMENTOR_ERROR_SPANNBEREICH:
            return {
                ...state,
                spannbereichError: action.spannbereichError,
            };

        case PARAMENTOR_MASCHINENHERSTELLER:
            return {
                ...state,
                maschinenhersteller: action.maschinenhersteller,
            };

        case PARAMENTOR_MASCHINE:
            return {
                ...state,
                maschine: action.maschine,
            };

        case PARAMENTOR_SAEGEBANDABMESSUNG:
            return {
                ...state,
                saegebandabmessung: action.saegebandabmessung,
            };

        case PARAMENTOR_BANDMATERIALTYP:
            return {
                ...state,
                bandmaterialtyp: action.bandmaterialtyp,
            };

        case PARAMENTOR_BANDBESCHICHTUNG:
            return {
                ...state,
                bandbeschichtung: action.bandbeschichtung,
            };

        case PARAMENTOR_ERZEUGNIS:
            return {
                ...state,
                erzeugnis: action.erzeugnis,
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTUECK_FORM:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    form: action.form,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTUECK_DURCHMESSER:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    durchmesser: action.durchmesser,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTUECK_HOEHE:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    hoehe: action.hoehe,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTUECK_WANDSTAERKE:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    wandstaerke: action.wandstaerke,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_TYP:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    traegerTyp: action.traegerTyp,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTUECK_TRAEGER_ABMESSUNG:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    traegerAbmessung: action.traegerAbmessung,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTOFF:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    werkstoff: action.werkstoff,
                },
            };

        case PARAMENTOR_ERZEUGNIS_WERKSTOFFGRUPPE:
            return {
                ...state,
                erzeugnis: {
                    ...state.erzeugnis,
                    werkstoffgruppe: action.werkstoffgruppe,
                },
            };

        case PARAMENTOR_VERGUETUNGSART:
            return {
                ...state,
                verguetungsart: action.verguetungsart,
            };

        case PARAMENTOR_GEFUEGEART:
            return {
                ...state,
                gefuegeart: action.gefuegeart,
            };

        case PARAMENTOR_KUEHLUNGSART:
            return {
                ...state,
                kuehlungsart: action.kuehlungsart,
            };

        case PARAMENTOR_LEISTUNGSVORGABE:
            return {
                ...state,
                leistungsvorgabe: action.leistungsvorgabe,
            };

        case PARAMENTOR_LAGENSCHNITT:
            return {
                ...state,
                lagenschnitt: action.lagenschnitt,
            };

        case PARAMENTOR_ANZAHLPROLAGE:
            return {
                ...state,
                anzahlProLage: action.anzahlProLage,
            };

        case PARAMENTOR_ANZAHLLAGEN:
            return {
                ...state,
                anzahlLagen: action.anzahlLagen,
            };

        case PARAMENTOR_VORHANDENES_SAEGEBAND:
            return {
                ...state,
                vorhandenesSaegeband: action.produkt,
            };

        case PARAMENTOR_VORHANDENES_SAEGEBAND_AUSFUEHRUNG:
            return {
                ...state,
                vorhandenesSaegebandAusfuehrung: action.saegeband,
            };

        case PARAMENTOR_PRODUKTEMPFEHLUNG:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        produktempfehlungLevel1: action.produktempfehlung,
                    };

                case 2:
                    return {
                        ...state,
                        produktempfehlungLevel2: action.produktempfehlung,
                    };

                case 3:
                    return {
                        ...state,
                        produktempfehlungLevel3: action.produktempfehlung,
                    };
            }
            return state;
        
        case PARAMENTOR_PRODUKTEMPFEHLUNG_FAVORITES_LIST: {
            return {
                ...state,
                produktempfehlungFavoritesList: action.favorites
            }
        }

        case PARAMENTOR_PARAMETEREMPFEHLUNG:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        parameterempfehlungLevel1: action.parameterempfehlung,
                    };

                case 2:
                    return {
                        ...state,
                        parameterempfehlungLevel2: action.parameterempfehlung,
                    };

                case 3:
                    return {
                        ...state,
                        parameterempfehlungLevel3: action.parameterempfehlung,
                    };

                case 4:
                    return {
                        ...state,
                        parameterempfehlungVorhandenesSaegeband: action.parameterempfehlung,
                    };
            }
            return state;

        case PARAMENTOR_KOSTEN_MASCHINENKOSTEN:
            return {
                ...state,
                maschinenkosten: action.maschinenkosten,
            };

        case PARAMENTOR_KOSTEN_KOSTENPROBEDIENER:
            return {
                ...state,
                kostenProBediener: action.kostenProBediener,
            };

        case PARAMENTOR_KOSTEN_PREISPROBAND:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        preisProBandLevel1: action.preisProBand,
                    };

                case 2:
                    return {
                        ...state,
                        preisProBandLevel2: action.preisProBand,
                    };

                case 3:
                    return {
                        ...state,
                        preisProBandLevel3: action.preisProBand,
                    };

                case 4:
                    return {
                        ...state,
                        preisProBandVorhandenesSaegeband: action.preisProBand,
                    };
            }
            return state;

        case PARAMENTOR_KOSTEN_STANDFLAECHE:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        standflaecheLevel1: action.standflaeche,
                    };

                case 2:
                    return {
                        ...state,
                        standflaecheLevel2: action.standflaeche,
                    };

                case 3:
                    return {
                        ...state,
                        standflaecheLevel3: action.standflaeche,
                    };

                case 4:
                    return {
                        ...state,
                        standflaecheVorhandenesSaegeband: action.standflaeche,
                    };
            }
            return state;

        case PARAMENTOR_KOSTEN_STANDFLAECHE_TYP:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        standflaecheTypLevel1: action.standflaecheTyp,
                    };

                case 2:
                    return {
                        ...state,
                        standflaecheTypLevel2: action.standflaecheTyp,
                    };

                case 3:
                    return {
                        ...state,
                        standflaecheTypLevel3: action.standflaecheTyp,
                    };

                case 4:
                    return {
                        ...state,
                        standflaecheTypVorhandenesSaegeband: action.standflaecheTyp,
                    };
            }
            return state;

        case PARAMENTOR_KOSTEN_MASCHINENPROBEDIENER:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        maschinenProBedienderLevel1: action.maschinenProBediener,
                    };

                case 2:
                    return {
                        ...state,
                        maschinenProBedienderLevel2: action.maschinenProBediener,
                    };

                case 3:
                    return {
                        ...state,
                        maschinenProBedienderLevel3: action.maschinenProBediener,
                    };

                case 4:
                    return {
                        ...state,
                        maschinenProBedienderVorhandenesSaegeband: action.maschinenProBediener,
                    };
            }
            return state;

        case PARAMENTOR_KOSTEN_KOSTENERSPARNIS:
            switch (action.level) {
                case 1:
                    return {
                        ...state,
                        kostenersparnisLevel1: action.kostenersparnis,
                    };

                case 2:
                    return {
                        ...state,
                        kostenersparnisLevel2: action.kostenersparnis,
                    };

                case 3:
                    return {
                        ...state,
                        kostenersparnisLevel3: action.kostenersparnis,
                    };

                case 4:
                    return {
                        ...state,
                        kostenersparnisVorhandenesSaegeband: action.kostenersparnis,
                    };
            }
            return state;

        case PARAMENTOR_SESSIONS:
          return {
            ...state,
            sessions: action.sessions,
          };

        case PARAMENTOR_SESSION_DELETED:
          return {
            ...state,
            sessions: [
              ...state.sessions.filter(s => s.id !== action.session.id)
            ],
          };

        case PARAMENTOR_SESSION_ADDED:
          return {
            ...state,
            sessions: [
              ...state.sessions,
              action.session
            ],
          };

        default:
            return state;
    }
}
